import { render } from "./Mo_addchg_row.vue?vue&type=template&id=280ad662&scoped=true&ts=true"
import script from "./Mo_addchg_row.vue?vue&type=script&lang=ts"
export * from "./Mo_addchg_row.vue?vue&type=script&lang=ts"

import "./Mo_addchg_row.vue?vue&type=style&index=0&id=280ad662&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1530414395/src/mediadept-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-280ad662"]])

export default __exports__